export const roundingWidthSets = {
  standard: [
    298, 480, 697, 960, 1020, 1394, 1920,
  ],
}

export const getImageSizeURL = ({
  width, height, roundingWidths, src,
}) => {
  const pixelRatio = (typeof window.devicePixelRatio === 'undefined') ? 1 : window.devicePixelRatio
  const layoutRatio = width / height
  let processedWidth = width * pixelRatio
  if (roundingWidths) {
    processedWidth = roundDimensionValueForCaching(processedWidth, roundingWidths)
  }
  return src.replace('{width}', processedWidth).replace('%7Bwidth%7D', processedWidth).replace('{height}', parseInt(processedWidth / layoutRatio)).replace('%7Bheight%7D', parseInt(processedWidth / layoutRatio))
}

export const isImageSizeComputable = (element) => {
  const computedStyle = window.getComputedStyle(element)
  return (computedStyle.display !== 'none' && element.offsetWidth > 0 && element.offsetHeight > 0)
}

const roundDimensionValueForCaching = (dimensionValue, roundingWidths) => {
  let index
  for (index = roundingWidths.length - 2; index >= 0; index--) {
    if (dimensionValue > roundingWidths[index]) {
      return roundingWidths[index + 1]
    }
  }
  return roundingWidths[0]
}
